<template>
  <div class="upload-status">
    <div
      class="image-wrapper"
      :class="{ 'image-loading-borders': isUploading, 'error': isError, 'image-set': isImageSet }"
    >
      <img
        v-if="isUploading || isSuccess"
        :src="image"
        class="image-preview"
        alt="Image preview"
      >
      <alert-triangle-icon
        v-else-if="isError"
        size="16"
        class="image-preview alert-icon"
      />
    </div>
    <div class="text-and-progress">
      <div class="w-100 d-flex justify-content-between">
        <span class="file-name">
          {{ file.name }}
        </span>
        <span
          v-if="isUploading"
          class="progress-percentage"
        >
          {{ progressPercentage }}%
        </span>
      </div>
      <div v-if="isSuccess">
        <span class="file-size">
          {{ getFileSize(file.size) }}
        </span>
      </div>
      <div v-else-if="isError">
        <span class="error-text">
          Something went wrong.
        </span>
        <p
          class="error-text cursor-pointer font-weight-bold"
          @click="() => removeImage('try-again')"
        >
          Try again.
        </p>
      </div>
      <div
        v-else-if="isUploading"
        class="progress-bar"
      >
        <div
          class="progress"
          :style="{ width: progressPercentage + '%' }"
        />
      </div>
    </div>
    <div
      class="post-icon"
    >
      <trash-2-icon
        v-if="isDeleteEnabled && isSuccess"
        size="1.5x"
        @click="removeImage('delete')"
      />
      <div
        v-else-if="isSuccess"
        class="success-icon"
      >
        <check-icon />
      </div>
      <x-icon
        v-else
        @click="stopUpload"
      />
    </div>
  </div>
</template>
<script>
import {
 XIcon, CheckIcon, AlertTriangleIcon, Trash2Icon,
} from 'vue-feather-icons'
import notesIcon from '@/assets/images/icons/notes.svg'
import { getFileSize } from '@/utils/fileUtils'

export default {
  name: 'UploadStatus',
  components: {
    XIcon,
    CheckIcon,
    AlertTriangleIcon,
    Trash2Icon,
  },
  props: {
    isUploading: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    progressPercentage: {
      type: Number,
      default: 0,
    },
    file: {
      type: File,
      default: null,
    },
    isDeleteEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    image() {
      return this.file && this.isSuccess ? URL.createObjectURL(this.file) : notesIcon
    },
    isImageSet() {
      return this.file && this.isSuccess
    },
  },
  methods: {
    getFileSize,
    removeImage(type) {
      this.$emit('remove-image', type)
    },
    stopUpload() {
      this.$emit('stop-upload')
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-status {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 10px;
}

.image-wrapper {
  border-radius: 50%;
  position: relative;
  width: 36px;
  height: 36px;
  background-color: #EFF8FE;
}

.image-wrapper.error {
  background-color: #FEF1F1;
}

.image-wrapper.image-set {
  width: 100px;
  .image-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.alert-icon {
  color: #EB4143;
  font-size: 16px;
}

.image-loading-borders {
  outline: 2px solid rgba(56, 188, 247, 0.16);
  outline-offset: 3px;
  border: 2px solid rgba(56, 188, 247, 0.32);
}

.image-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  object-fit: cover;
}

.text-and-progress {
  display: flex;
  flex-direction: column;
  width: calc(100% - 90px);
  margin-left: 16px;
  margin-right: 16px;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background-color: #E0E3E6;
  margin-top: 8px;
}

.progress {
  height: 4px;
  width: 40%;
  background-color: #0368A0;
}

.progress-percentage {
  font-size: 14px;
  color: #61646B;
  line-height: 20px;
}

.file-size {
  font-size: 12px;
  color: #61646B;
}

.error-text {
  font-size: 12px;
  color: #B51D1D;
}

.post-icon {
  cursor: pointer;
  color: #94979E;
  &:hover {
    color: #B51D1D;
  }
  transition: all 0.3s ease-in-out;
}

.success-icon {
  color: rgba(38, 191, 86, 1);
}
</style>
